import React, { useEffect, useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { CustomBtn } from '../../../components/button/button';
 
import ReactDOM from 'react-dom';
import ReportCard from './reportCard';

export default function FormTable(props) {
    // console.log(props)
    // const student = props.data.find(student => student.StudentSrn === 246);
    // if (student) {
    //     //console.log('Student found:', student);
    // } else {
    //     //console.log('Student not found');
    // }

    const [selectData, setSelectData] = useState([]);

    const calculateStatus = (one, two) =>{
        const secureMarks = parseInt(one.split('/')[0]) + parseInt(two.split('/')[0]) 
        const totMarks = parseInt(one.split('/')[1]) + parseInt(two.split('/')[1])
        const calcStatus = (secureMarks * 100) / totMarks 
        const nameStatus = calcStatus >= 90 ? 'ممتاز' : calcStatus >= 80 && calcStatus <= 90 ? 'جیدجداً': calcStatus>= 50 && calcStatus <= 80 ? 'جید' :  calcStatus>= 40 && calcStatus <= 50 ? 'مقبول' : 'ناکام'
        // //console.log(calcStatus, nameStatus)
        return nameStatus;
    }
    useEffect(() => {
        if (props.data && props.data) {
            if(props.data[0]?.TotalGainedNumbers2 || props.data[1]?.TotalGainedNumbers2){
                const addFinalPosition = props.data.map( item => ({
                    ...item,
                    totalBothMarks : parseInt(item.TotalGainedNumbers1.split('/')[0]) + parseInt(item.TotalGainedNumbers2.split('/')[0]),
                    statusFinal : calculateStatus(item.TotalGainedNumbers1, item.TotalGainedNumbers2) 
                }))
                // //console.log(addFinalPosition)
                const sortAgainstTotalMarks = addFinalPosition.sort((a, b) => b.totalBothMarks - a.totalBothMarks);
                sortAgainstTotalMarks.forEach((item, index) => {
                    item.PositionFinal = index + 1; // Adding the position (1-based index)
                  });
                setSelectData(sortAgainstTotalMarks)
            }
            else{
                const sortedData2 = props.data.sort((a, b) => a.Position - b.Position);
                setSelectData(sortedData2);
            }
        }
    }, [props.data]);
 
    const printReportCard = async (getRecord) => {
         const newWindow = window.open('', '_blank', 'width=1000,height=800,left=100,top=100');
        newWindow.document.body.innerHTML = '<div id="root"></div>';
        const cssLink = newWindow.document.createElement('link');
        cssLink.rel = 'stylesheet';
        const url = window.location.href;
        const catchUrl = url.replace("/Private/StudentResult", "");
        cssLink.href = `${catchUrl}/reportCard.css`;
        newWindow.document.head.appendChild(cssLink);
    

        // Render React component with props
        ReactDOM.render(<ReportCard rec={getRecord}  />, newWindow.document.getElementById('root'));
    };
    const getNameFName = (marksDetail) =>{
        const marksArray = Object.values(marksDetail);
        if (marksArray.length > 0) {
            const firstDetail = marksArray[0];
            return `${firstDetail.Name_P} / ${firstDetail.FName_P}`;
        }
    }
    
    return (
        <TableContainer component={Paper}>
            <div>{selectData[0]?.Date}</div>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Roll Number</TableCell>
                        <TableCell>Name</TableCell>
                        <TableCell>Position</TableCell>
                        <TableCell>Grad</TableCell>
                        <TableCell></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {selectData.length > 0 ? (
                        selectData.map((row) => (
                            <TableRow key={row.StudentSrn}>
                                <TableCell>{row.StudentSrn}</TableCell>
                                <TableCell>{getNameFName(row.marksDetail)}</TableCell>
                                <TableCell>{selectData?.Term == 0 ? row.Position : row.Position2}</TableCell>
                                <TableCell>{selectData?.Term == 0 ?  row.Status : row.Status2}</TableCell>
                                <TableCell>
                                    <CustomBtn type="button" click={()=>printReportCard(row)} data="اطلاعنامه" />
                                </TableCell>
                            </TableRow>
                        ))
                    ) : (
                        <TableRow>
                            <TableCell colSpan={4}>No data available</TableCell>
                        </TableRow>
                    )}
                </TableBody>
            </Table>
        </TableContainer>
    );
}
